/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComposedModal, ComposedModalProps } from '@eigtech/ui-shared-dave'
import { ReactNode } from 'react'
import { FieldValues, SubmitHandler } from 'react-hook-form'
import { FormApi } from '../useForm'

export type FormModalProps<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues,
> = ComposedModalProps & {
  form: FormApi<TFieldValues, TContext, TTransformedValues>
  submitButton?: ReactNode
  onSubmit: SubmitHandler<TTransformedValues> | undefined
}

export function FormModal<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues,
>({
  children,
  form,
  submitButton,
  onSubmit,
  ...props
}: FormModalProps<TFieldValues, TContext, TTransformedValues>) {
  const {
    formState: { isSubmitting },
  } = form

  return (
    <ComposedModal
      closeButtonProps={{ isDisabled: isSubmitting }}
      footerActionsRight={
        !submitButton || typeof submitButton === 'string' ? (
          <form.SubmitButton>{submitButton}</form.SubmitButton>
        ) : (
          submitButton
        )
      }
      footerCloseButtonProps={{ isDisabled: isSubmitting }}
      {...props}
    >
      {onSubmit ? <form.Form onSubmit={onSubmit}>{children}</form.Form> : children}
    </ComposedModal>
  )
}
